import styled from "styled-components";
import { theme } from "../theme/lexusTheme";
import { IconWrapper } from "../globals/IconWrapper";
import { captionStyle } from "../globals/Type";

export const Info = styled.div`
    ${captionStyle};
    display: flex;
    align-items: flex-start;
    margin-bottom: ${theme.space[3]}px;
    text-transform: none;
    color: ${theme.colors.midnight};

    ${IconWrapper} {
        margin-inline-end: ${theme.space[2]}px;
    }
`;
